module.exports = __webpack_public_path__ + "img/quest_icon_0000_formula.aae08e66.png";